module.exports = __webpack_public_path__ + "media/components/login/static/background-6d00e163f704dd37ba519aafeb831d7b.jpg";